"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=collection.move.to.job.js.map